import {
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    Paper,
    TableBody,
    Typography
} from '@mui/material';

const CB_EQUIPMENT_TRANSPORT_HEADERS = [
    'Date',
    'List Equipment Transported',
    'Mass of Equipment (metric tonne)',
    'Distance Transported (km)',
    'Fuel Type',
    'Transport Type'
]

export default function CbEquipmentTransport({ equipmentData }) {
    return (
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h5">
                Equipment Transport
            </Typography>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {CB_EQUIPMENT_TRANSPORT_HEADERS.map((header) => (
                                <TableCell
                                    key={header}
                                    align='left'>
                                    {header}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {equipmentData?.map((equipmentItem, index) => (
                            <TableRow key={index}>
                                <TableCell align="left">{equipmentItem.date}</TableCell>
                                <TableCell align="left">{equipmentItem.equipmentList}</TableCell>
                                <TableCell align="left">{equipmentItem.equipmentMass}</TableCell>
                                <TableCell align="left">{equipmentItem.distance}</TableCell>
                                <TableCell align="left">{equipmentItem.fuelType}</TableCell>
                                <TableCell align="left">{equipmentItem.transportType}</TableCell>
                            </TableRow>
                        )
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    )
}
